// angular.module('HeroPRO')
//     .directive('smartyStreetsInput', smartyStreetsInput);

import _ from 'lodash';

/* @ngInject */
export default function smartyStreetsInput(raSmarty) {
    const directive = {
        restrict: 'EA',
        controller: smartyController,
        scope: {
            smartyModel: '=',
            labelAbove: '=',
            labelBelow: '=',
            smartyClass: '@',
            smartyId: '@',
            smartyName: '@',
            smartyPlaceholder: '@',
            labelName: '@',
            smartyZipcode: '&',
            stateFilter: '=',
        },

        templateUrl(element, attr) {
            return attr.template || 'app/common/smarty/smarty-template.html';
        },
        controllerAs: 'smartyCtrl',
        bindToController: true,
        transclude: true,
    };
    smartyController.$inject = ["$rootScope"];
    return directive;

    function smartyController($rootScope) {
        let vm = this,
            dataObject = {},
            suggestionObject = {},
            suggestionNumber = 0,
            canBlur = true,
            street = '',
            city = '',
            state = '',
            suggestionText = '';
        vm.listAddresses = [];
        vm.noSuggestions = raSmarty.config.noSuggestionsMessage;
        vm.sorryMessage = raSmarty.config.errorMessage;

        vm.showList = false;
        vm.showResults = true;
        vm.successResult = false;
        vm.selected = 0;
        vm.getSmartyAddress = getSmartyAddress;
        vm.verifySmartyAddress = verifySmartyAddress;
        vm.hideList = hideList;
        vm.revealList = revealList;
        vm.handleBlur = handleBlur;
        vm.handleResultMouseDown = handleResultMouseDown;

        // init smarty in the pristine state
        smartyPristine();

        function getSmartyAddress(address, keyCode) {
            revealList();
            // 40 = down arrow, 38 = up arrow, 39 = right arrow, 37 = left arrow, 13 = enter, 9 = tab
            if (keyCode !== 40 && keyCode !== 38 && keyCode !== 39 && keyCode !== 37 && keyCode !== 13 && keyCode !== 9) {
                raSmarty.getAddress(address, vm.stateFilter)
                    .then((data) => {
                        if (data.suggestions !== null && (data.suggestions.length !== undefined || data.suggestions.length !== null)) {
                            vm.selected = 0;
                            vm.showResults = true;
                            vm.pristine = true;
                            vm.invalid = false;
                            vm.valid = false;
                            if (data.suggestions[vm.selected] !== undefined) {
                                suggestionObject = data.suggestions;
                                vm.listAddresses = suggestionObject;
                                suggestionNumber = data.suggestions.length;
                                street = data.suggestions[vm.selected].street_line;
                                city = data.suggestions[vm.selected].city;
                                state = data.suggestions[vm.selected].state;
                                suggestionText = data.suggestions[vm.selected].text;
                            }
                        } else {
                            vm.showResults = false;
                            vm.selected = -1;
                        }
                    });
            }

            // KEY COMMANDS
            if (keyCode === 40) { // down
                vm.selected++;
                if (vm.selected > suggestionNumber - 1) {
                    vm.selected = 0;
                }
            }
            if (keyCode === 38) { // up
                vm.selected--;
                if (vm.selected < 0) {
                    vm.selected = suggestionNumber - 1;
                }
            }

            if (suggestionObject[vm.selected] !== undefined) {
                if (keyCode === 13 || keyCode === 9) {
                    vm.verifySelectedSmartyAddress(vm.selected);
                }
            } else if (keyCode === 13 || keyCode === 9) {
                hideList();
                smartyInvalid();
            }
        }

        // Added method to extract secondary information with # if it exists.
        // Extracting secondary is not needed for all cases where Secondary contains alphanumeric values such as Unit 161.
        vm.verifySelectedSmartyAddress = function (index) {
            // console.log(suggestionObject[index]);
            let secondaryLine = '';

            const indexOfPound = suggestionObject[index].street_line.indexOf('#');
            // Check if address even has a #
            if (indexOfPound > -1) {
                const splitAddress = suggestionObject[index].street_line.split(' ');
                const address = suggestionObject[index].street_line.substring(0, indexOfPound);
                const poundIndex = _.indexOf(splitAddress, '#');

                // Handle case where the # is spaced separate from the number.
                if (splitAddress[poundIndex].length > 1) {
                    secondaryLine = splitAddress[poundIndex];
                } else {
                    secondaryLine = `${splitAddress[poundIndex]} ${splitAddress[poundIndex + 1]}`;
                }
                verifySmartyAddress(
                    address, secondaryLine, suggestionObject[index].city, suggestionObject[index].state,
                    index, suggestionObject[index].propertyId, suggestionObject[index].source,
                );
            } else {
                // No secondary with #, so verify normally.
                verifySmartyAddress(
                    suggestionObject[index].street_line, null, suggestionObject[index].city,
                    suggestionObject[index].state, index, suggestionObject[index].propertyId, suggestionObject[index].source,
                );
            }
        };

        function verifySmartyAddress(street, secondary, city, state, index, propertyId, source) {
            hideList();
            vm.selected = index;
            raSmarty.verifyAddress(street, secondary, city, state, propertyId, source)
                .then((result) => {
                    vm.successResult = true;
                    if (!!result.data.Data && result.data.Data.length > 0) {
                        const res = result.data.Data[0];
                        vm.smartyModel.isValid = true;
                        vm.smartyModel.addressText = res.Address || `${res.delivery_line_1} ${res.last_line}`;
                        vm.smartyModel.dpvMatchCode = res.analysis.dpv_match_code;
                        dataObject = {
                            street: res.delivery_line_1,
                            city: res.components.city_name,
                            state: res.components.state_abbreviation,
                            unit: res.components.secondary_number,
                            zipcode: res.components.zipcode,
                            addressData: res.components,
                        };
                        angular.extend(vm.smartyModel, dataObject);
                        smartyValid();
                    } else {
                        vm.successResult = false;
                        vm.smartyModel.isValid = false;
                        smartyInvalid();

                        if (vm.selected && suggestionObject[vm.selected]) {
                            vm.smartyModel.addressText = suggestionObject[vm.selected].text;
                        }

                        dataObject = {};
                        angular.extend(vm.smartyModel, dataObject);
                    }
                });
        }

        function hideList() {
            vm.showList = false;
        }

        function revealList() {
            vm.showList = true;
        }

        function handleResultMouseDown() {
            canBlur = false;
        }

        // this will hide our list if we can blur, along with selecting the suggestion on select
        function handleBlur() {
            if (canBlur) {
                hideList();
                if (suggestionObject[vm.selected] !== undefined) {
                    vm.verifySelectedSmartyAddress(vm.selected);
                }
            } else {
                canBlur = true;
            }
        }

        /* Private Functions */
        function smartyValid() {
            vm.valid = true;
            vm.pristine = false;
            vm.invalid = false;
        }

        function smartyInvalid() {
            vm.valid = false;
            vm.pristine = false;
            vm.invalid = true;
        }

        function smartyPristine() {
            vm.valid = false;
            vm.invalid = false;
            vm.pristine = true;
        }

        function showInvalidAddressDropDown() {
            hideList();
            smartyInvalid();
        }

        $rootScope.$on("triggerShowInvalidAddressDropDown", function() {
            showInvalidAddressDropDown();
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/common/smarty/ra-smarty-streets.js